// src/api/upload.js
import request from './index';

export function addText(file) {
  return request.post('officialPageObject/addOrUpdate', file, {
  });
}
